import revu from 'images/index-page/index-revu.png';
import React, { ReactElement } from 'react';
import { product } from 'copy/copy';

const Interstitial = (): ReactElement => {
  return (
    <div className="index-interstitial">
      <div className="index__container">
        <div className="w100 index-interstitial__content">
          <div className="index-interstitial__column center">
            <img
              className="index-interstital__revu"
              src={revu}
              alt="Revu Integration"
            />
          </div>
          <div
            className="index-interstitial__column font-size-8 row items-center"
            style={{ color: '#fff' }}
          >
            <div className="index-interstital__text">
              {product.productName} is fully compatible with PDFs and Studio
              Project files from Revu
              <sup className="font-size-4">®</sup>, so you can easily{' '}
              <span className="bold">
                leverage the power of markups whenever, wherever
              </span>
              .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Interstitial;
